export default __webpack_public_path__ + "static/valuation_img_2-33c678be42065309fa251ddd6359127b.png";